import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import BarbaApp from './barba/BarbaApp';
import './components/menu';
import './components/BackgroundAnimation';
import './components/VideoPlayer';
import './components/plausible';
import { clipping } from './components/clipping';
export class DRN {
	constructor() {
		Promise.all([DRN.domReady()]).then(() => this.init());
	}

	init() {
		clipping.init();
		new BarbaApp();
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new DRN();
